import React, { Component, ReactNode } from 'react'

interface ErrorBoundaryProps {
  children?: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)

    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    if (globalThis.newrelic?.noticeError) {
      globalThis.newrelic.noticeError(
        `ErrorBoundary getDerivedStateFromError called with error: ${error.message}`,
      )
    }

    return { hasError: true }
  }

  componentDidCatch(error: Error): void {
    if (globalThis.newrelic?.noticeError) {
      globalThis.newrelic?.noticeError(
        `ErrorBoundary componentDidCatch called with error: ${error.message}`,
      )
    }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div>
          <style>
            {`html, body {
                width: 100%;
                height: 100%;
                padding: 0;
                margin: 0;
                display: flex;
                justify-content: center;
                align-items: center;
            }`}
          </style>
          <h1>Oops, there is an error!</h1>
          <p>
            Let's start a{' '}
            <a href="/search" style={{ color: 'cornflowerblue' }}>
              new search
            </a>
            .
          </p>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
